module.exports = __webpack_public_path__ + "img/hellvape.15ba9d0b.png";